import React from 'react'

export const IconBurgerExpand = (props={}) => {
	const { size=20, imgSize=8, strokeWidth=1.5 } = props
	const k = 14.0 / 8.0

	return <>
		<svg width={`${size}px`} height={`${k * size}px`} viewBox={`0 0 ${imgSize} ${k * imgSize}`} stroke="currentColor" fill="none" strokeWidth={strokeWidth} xmlns="http://www.w3.org/2000/svg">
			<path d="M1 13L7 7L1 1" strokeLinecap="round" strokeLinejoin="round"/>
		</svg>
	</>
}
